import * as React from "react"

import { cn, capitalizeWords } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, onChange, autoCapitalize = true, ...props }, ref) => {
  const handleChange = (e) => {
    if (autoCapitalize && e.target.value) {
      // Capitalize first letter of each word
      const cursorPos = e.target.selectionStart;
      const originalLength = e.target.value.length;
      e.target.value = capitalizeWords(e.target.value);
      const newLength = e.target.value.length;
      
      // Restore cursor position
      const newCursorPos = cursorPos + (newLength - originalLength);
      setTimeout(() => {
        if (e.target.setSelectionRange) {
          e.target.setSelectionRange(newCursorPos, newCursorPos);
        }
      }, 0);
    }
    
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      onChange={handleChange}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
